import { buildRouteHead } from "@/lib/seo/routeHead";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/es/webinars/drug-device-combination-products-article-117")({
  head: () => buildRouteHead("/es/webinars/drug-device-combination-products-article-117", { noIndex: true }),
  beforeLoad: () => {
    throw redirect({ href: "/es/webinars/productos-sanitarios-combinados-con-medicamentos-y-articulo-117", replace: true });
  },
});
